import { Component as e, useRef as t, useEffect as n, useMemo as r } from "react";
import i from "prop-types";
function o(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function a(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function s(e, t, n) {
  return t && a(e.prototype, t), n && a(e, n), e;
}
function u(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function c(e, t) {
  return (c = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function l(e) {
  return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}
function h(e, t) {
  return !t || "object" !== l(t) && "function" != typeof t ? u(e) : t;
}
function f(e) {
  return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function d(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a),
      u = s.value;
  } catch (e) {
    return void n(e);
  }
  s.done ? t(u) : Promise.resolve(u).then(r, i);
}
function p(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (r, i) {
      var o = e.apply(t, n);
      function a(e) {
        d(o, r, i, a, s, "next", e);
      }
      function s(e) {
        d(o, r, i, a, s, "throw", e);
      }
      a(void 0);
    });
  };
}
function v(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function m(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
      var n = [],
        r = !0,
        i = !1,
        o = void 0;
      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }
      return n;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return v(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var g,
  y = (function (e) {
    var t = function (e) {
      var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        s = i.toStringTag || "@@toStringTag";
      function u(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        u({}, "");
      } catch (e) {
        u = function u(e, t, n) {
          return e[t] = n;
        };
      }
      function c(e, t, n, r) {
        var i = t && t.prototype instanceof m ? t : m,
          o = Object.create(i.prototype),
          a = new O(r || []);
        return o._invoke = function (e, t, n) {
          var r = h;
          return function (i, o) {
            if (r === d) throw new Error("Generator is already running");
            if (r === p) {
              if ("throw" === i) throw o;
              return S();
            }
            for (n.method = i, n.arg = o;;) {
              var a = n.delegate;
              if (a) {
                var s = A(a, n);
                if (s) {
                  if (s === v) continue;
                  return s;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === h) throw r = p, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = d;
              var u = l(e, t, n);
              if ("normal" === u.type) {
                if (r = n.done ? p : f, u.arg === v) continue;
                return {
                  value: u.arg,
                  done: n.done
                };
              }
              "throw" === u.type && (r = p, n.method = "throw", n.arg = u.arg);
            }
          };
        }(e, n, a), o;
      }
      function l(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = c;
      var h = "suspendedStart",
        f = "suspendedYield",
        d = "executing",
        p = "completed",
        v = {};
      function m() {}
      function g() {}
      function y() {}
      var b = {};
      b[o] = function () {
        return this;
      };
      var w = Object.getPrototypeOf,
        _ = w && w(w(x([])));
      _ && _ !== n && r.call(_, o) && (b = _);
      var T = y.prototype = m.prototype = Object.create(b);
      function k(e) {
        ["next", "throw", "return"].forEach(function (t) {
          u(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function E(e, t) {
        function n(i, o, a, s) {
          var u = l(e[i], e, o);
          if ("throw" !== u.type) {
            var c = u.arg,
              h = c.value;
            return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function (e) {
              n("next", e, a, s);
            }, function (e) {
              n("throw", e, a, s);
            }) : t.resolve(h).then(function (e) {
              c.value = e, a(c);
            }, function (e) {
              return n("throw", e, a, s);
            });
          }
          s(u.arg);
        }
        var i;
        this._invoke = function (e, r) {
          function o() {
            return new t(function (t, i) {
              n(e, r, t, i);
            });
          }
          return i = i ? i.then(o, o) : o();
        };
      }
      function A(e, n) {
        var r = e.iterator[n.method];
        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator.return && (n.method = "return", n.arg = t, A(e, n), "throw" === n.method)) return v;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return v;
        }
        var i = l(r, e.iterator, n.arg);
        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, v;
        var o = i.arg;
        return o ? o.done ? (n[e.resultName] = o.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
      }
      function L(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function I(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function O(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(L, this), this.reset(!0);
      }
      function x(e) {
        if (e) {
          var n = e[o];
          if (n) return n.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var i = -1,
              a = function n() {
                for (; ++i < e.length;) if (r.call(e, i)) return n.value = e[i], n.done = !1, n;
                return n.value = t, n.done = !0, n;
              };
            return a.next = a;
          }
        }
        return {
          next: S
        };
      }
      function S() {
        return {
          value: t,
          done: !0
        };
      }
      return g.prototype = T.constructor = y, y.constructor = g, g.displayName = u(y, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, u(e, s, "GeneratorFunction")), e.prototype = Object.create(T), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, k(E.prototype), E.prototype[a] = function () {
        return this;
      }, e.AsyncIterator = E, e.async = function (t, n, r, i, o) {
        void 0 === o && (o = Promise);
        var a = new E(c(t, n, r, i), o);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, k(T), u(T, s, "Generator"), T[o] = function () {
        return this;
      }, T.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var n in e) t.push(n);
        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }
          return n.done = !0, n;
        };
      }, e.values = x, O.prototype = {
        constructor: O,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;
          function i(r, i) {
            return s.type = "throw", s.arg = e, n.next = r, i && (n.method = "next", n.arg = t), !!i;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
              s = a.completion;
            if ("root" === a.tryLoc) return i("end");
            if (a.tryLoc <= this.prev) {
              var u = r.call(a, "catchLoc"),
                c = r.call(a, "finallyLoc");
              if (u && c) {
                if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return i(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return i(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var i = this.tryEntries[n];
            if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }
          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), v;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.tryLoc === e) {
              var r = n.completion;
              if ("throw" === r.type) {
                var i = r.arg;
                I(n);
              }
              return i;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: x(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), v;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  }(g = {
    exports: {}
  }, g.exports), g.exports),
  b = "object" === ("undefined" == typeof window || "undefined" == typeof window ? "undefined" : l(window)),
  w = b ? document : {},
  _ = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange"];
function T(e, t) {
  var n;
  function r() {
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
    n && clearTimeout(n), n = setTimeout(function () {
      e.apply(void 0, i), n = null;
    }, t);
  }
  return r.cancel = function () {
    clearTimeout(n);
  }, r;
}
function k(e, t) {
  var n = 0;
  return function () {
    var r = new Date().getTime();
    if (!(r - n < t)) return n = r, e.apply(void 0, arguments);
  };
}
var E = 0,
  A = 0;
function L() {
  var e = new Date().getTime();
  return e === E ? 1e3 * e + ++A : (E = e, A = 0, 1e3 * e);
}
function I() {
  return Math.random().toString(36).substring(2);
}
function O() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
  return new Promise(function (t) {
    return setTimeout(t, e);
  });
}
function x() {
  return new Date().getTime();
}
var S = {
    create: function create(e) {
      var t = {
        messagesCallback: null,
        bc: new BroadcastChannel(e)
      };
      return t.bc.onmessage = function (e) {
        t.messagesCallback && t.messagesCallback(e.data);
      }, t;
    },
    close: function close(e) {
      e.bc.close();
    },
    onMessage: function onMessage(e, t) {
      e.messagesCallback = t;
    },
    postMessage: function postMessage(e, t) {
      try {
        return e.bc.postMessage(t, !1), Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    canBeUsed: function canBeUsed() {
      return "function" == typeof BroadcastChannel;
    },
    type: "broadcastChannel",
    averageResponseTime: function averageResponseTime() {
      return 150;
    },
    microSeconds: L
  },
  M = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e4;
      o(this, e), this.ttl = t, this.set = new Set(), this.timeMap = new Map();
    }
    return s(e, [{
      key: "has",
      value: function value(e) {
        return this.set.has(e);
      }
    }, {
      key: "add",
      value: function value(e) {
        this.timeMap.set(e, x()), this.set.add(e), this._removeTooOldValues();
      }
    }, {
      key: "clear",
      value: function value() {
        this.set.clear(), this.timeMap.clear();
      }
    }, {
      key: "_removeTooOldValues",
      value: function value() {
        for (var e = x() - this.ttl, t = this.set[Symbol.iterator]();;) {
          var n = t.next().value;
          if (!n) return;
          if (!(this.timeMap.get(n) < e)) return;
          this.timeMap.delete(n), this.set.delete(n);
        }
      }
    }]), e;
  }();
function D() {
  var e;
  if ("undefined" == typeof window) return null;
  try {
    e = window.localStorage, e = window["ie8-eventlistener/storage"] || window.localStorage;
  } catch (e) {}
  return e;
}
function P(e, t) {
  var n = e,
    r = function r(e) {
      e.key === n && t(JSON.parse(e.newValue));
    };
  return window.addEventListener("storage", r), r;
}
function j() {
  var e = D();
  if (!e) return !1;
  try {
    var t = "__check";
    e.setItem(t, "works"), e.removeItem(t);
  } catch (e) {
    return !1;
  }
  return !0;
}
var C = {
    create: function create(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (!j()) throw new Error("❌ localStorage cannot be used.");
      var n = I(),
        r = new M(t.removeTimeout),
        i = {
          channelName: e,
          uuid: n,
          eMIs: r
        };
      return i.listener = P(e, function (e) {
        i.messagesCallback && e.uuid !== n && e.token && !r.has(e.token) && (e.data.time && e.data.time < i.messagesCallbackTime || (r.add(e.token), i.messagesCallback(e.data)));
      }), i;
    },
    close: function close(e) {
      var t;
      t = e.listener, window.removeEventListener("storage", t);
    },
    onMessage: function onMessage(e, t, n) {
      e.messagesCallbackTime = n, e.messagesCallback = t;
    },
    postMessage: function postMessage(e, t) {
      return new Promise(function (n) {
        var r = e.channelName,
          i = {
            token: I(),
            time: new Date().getTime(),
            data: t,
            uuid: e.uuid
          },
          o = JSON.stringify(i);
        D().setItem(r, o);
        var a = document.createEvent("Event");
        a.initEvent("storage", !0, !0), a.key = r, a.newValue = o, window.dispatchEvent(a), n();
      });
    },
    canBeUsed: j,
    type: "localStorage",
    averageResponseTime: function averageResponseTime() {
      var e = navigator.userAgent.toLowerCase();
      return e.includes("safari") && !e.includes("chrome") ? 240 : 120;
    },
    microSeconds: L
  },
  N = new Set();
var B = {
    create: function create(e) {
      var t = {
        name: e,
        messagesCallback: null
      };
      return N.add(t), t;
    },
    close: function close(e) {
      N.delete(e);
    },
    onMessage: function onMessage(e, t) {
      e.messagesCallback = t;
    },
    postMessage: function postMessage(e, t) {
      return new Promise(function (n) {
        return setTimeout(function () {
          Array.from(N).filter(function (t) {
            return t.name === e.name;
          }).filter(function (t) {
            return t !== e;
          }).filter(function (e) {
            return !!e.messagesCallback;
          }).forEach(function (e) {
            return e.messagesCallback(t);
          }), n();
        }, 5);
      });
    },
    canBeUsed: function canBeUsed() {
      return !0;
    },
    type: "simulate",
    averageResponseTime: function averageResponseTime() {
      return 5;
    },
    microSeconds: L
  },
  R = [S, C];
function Y() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  if (e.type) {
    if ("simulate" === e.type) return B;
    var t = R.find(function (t) {
      return t.type === e.type;
    });
    if (t) return t;
    throw new Error("❌ Method ".concat(e.type, " is not supported."));
  }
  var n = R.find(function (e) {
    return e.canBeUsed();
  });
  if (!n) throw new Error("❌ No method found ".concat(JSON.stringify(R.map(function (e) {
    return e.type;
  }))));
  return n;
}
var F = function () {
  function e(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    o(this, e), this.name = t, this.options = n, this.method = Y(this.options), this.closed = !1, this._isListening = !1, this._onMessageListener = null, this._addEventListeners = {
      message: [],
      internal: []
    }, this._unSendMessagePromises = new Set(), this._beforeClose = [], this._preparePromises = null, X(this);
  }
  return s(e, [{
    key: "postMessage",
    value: function value(e) {
      if (this.closed) throw new Error("❌ Cannot post message after channel has closed");
      return U(this, "message", e);
    }
  }, {
    key: "postInternal",
    value: function value(e) {
      return U(this, "internal", e);
    }
  }, {
    key: "onmessage",
    get: function get() {
      return this._onMessageListener;
    },
    set: function set(e) {
      var t = {
        time: this.method.microSeconds(),
        fn: e
      };
      J(this, "message", this._onMessageListener), e && "function" == typeof e ? (this._onMessageListener = t, V(this, "message", t)) : this._onMessageListener = null;
    }
  }, {
    key: "addEventListener",
    value: function value(e, t) {
      V(this, e, {
        time: this.method.microSeconds(),
        fn: t
      });
    }
  }, {
    key: "removeEventListener",
    value: function value(e, t) {
      J(this, e, this._addEventListeners[e].find(function (e) {
        return e.fn === t;
      }));
    }
  }, {
    key: "close",
    value: function value() {
      var e = this;
      if (!this.closed) {
        this.closed = !0;
        var t = this._preparePromises ? this._preparePromises : Promise.resolve();
        return this._onMessageListener = null, this._addEventListeners.message = [], t.then(function () {
          return Promise.all(Array.from(e._unSendMessagePromises));
        }).then(function () {
          return Promise.all(e._beforeClose.map(function (e) {
            return e();
          }));
        }).then(function () {
          return e.method.close(e._state);
        });
      }
    }
  }, {
    key: "type",
    get: function get() {
      return this.method.type;
    }
  }, {
    key: "isClosed",
    value: function value() {
      return this.closed;
    }
  }]), e;
}();
function U(e, t, n) {
  var r = {
    time: e.method.microSeconds(),
    type: t,
    data: n
  };
  return (e._preparePromises ? e._preparePromises : Promise.resolve()).then(function () {
    var t = e.method.postMessage(e._state, r);
    return e._unSendMessagePromises.add(t), t.catch().then(function () {
      return e._unSendMessagePromises.delete(t);
    }), t;
  });
}
function X(e) {
  var t,
    n = e.method.create(e.name, e.options);
  (t = n) && "function" == typeof t.then ? (e._preparePromises = n, n.then(function (t) {
    e._state = t;
  })) : e._state = n;
}
function G(e) {
  return e._addEventListeners.message.length > 0 || e._addEventListeners.internal.length > 0;
}
function V(e, t, n) {
  e._addEventListeners[t].push(n), function (e) {
    if (!e._isListening && G(e)) {
      var t = function t(_t) {
          e._addEventListeners[_t.type].forEach(function (e) {
            _t.time >= e.time && e.fn(_t.data);
          });
        },
        n = e.method.microSeconds();
      e._preparePromises ? e._preparePromises.then(function () {
        e._isListening = !0, e.method.onMessage(e._state, t, n);
      }) : (e._isListening = !0, e.method.onMessage(e._state, t, n));
    }
  }(e);
}
function J(e, t, n) {
  e._addEventListeners[t] = e._addEventListeners[t].filter(function (e) {
    return e !== n;
  }), function (e) {
    if (e._isListening && !G(e)) {
      e._isListening = !1;
      var t = e.method.microSeconds();
      e.method.onMessage(e._state, null, t);
    }
  }(e);
}
var W = function () {
  function e(t, n) {
    var r = this;
    o(this, e), this._channel = t, this._options = n, this.isLeader = !1, this.isDead = !1, this.token = I(), this._isApplying = !1, this._reApply = !1, this._unloadFns = [], this._listeners = [], this._intervals = [], this._duplicateListeners = function () {}, this._duplicateCalled = !1, this._onBeforeDie = p(y.mark(function e() {
      return y.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
          case "end":
            return e.stop();
        }
      }, e);
    }));
    var i = function () {
      var e = p(y.mark(function e() {
        return y.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", r.die());
            case 1:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function () {
        return e.apply(this, arguments);
      };
    }();
    b && (window.addEventListener("beforeUnload", i), window.addEventListener("unload", i), this._unloadFns.push(["beforeUnload", i]), this._unloadFns.push(["unload", i]));
  }
  var t;
  return s(e, [{
    key: "applyOnce",
    value: function value() {
      var e = this;
      if (this.isLeader) return Promise.resolve(!1);
      if (this.isDead) return Promise.resolve(!1);
      if (this._isApplying) return this._reApply = !0, Promise.resolve(!1);
      this._isApplying = !0;
      var t = !1,
        n = function n(_n) {
          "leader" === _n.context && _n.token !== e.token && ("apply" === _n.action && _n.token > e.token && (t = !0), "tell" === _n.action && (t = !0));
        };
      return this._channel.addEventListener("internal", n), $(this, "apply").then(function () {
        return O(e._options.responseTime);
      }).then(function () {
        return t ? Promise.reject(new Error()) : $(e, "apply");
      }).then(function () {
        return O(e._options.responseTime);
      }).then(function () {
        return t ? Promise.reject(new Error()) : $(e);
      }).then(function () {
        return function (e) {
          e.isLeader = !0;
          var t = function t(_t2) {
            "leader" === _t2.context && "apply" === _t2.action && $(e, "tell"), "leader" !== _t2.context || "tell" !== _t2.action || e._duplicateCalled || (e._duplicateCalled = !0, e._duplicateListeners(), $(e, "tell"));
          };
          return e._channel.addEventListener("internal", t), e._listeners.push(t), $(e, "tell");
        }(e);
      }).then(function () {
        return !0;
      }).catch(function () {
        return !1;
      }).then(function (t) {
        return e._channel.removeEventListener("internal", n), e._isApplying = !1, !t && e._reApply ? (e._reApply = !1, e.applyOnce()) : t;
      });
    }
  }, {
    key: "awaitLeadership",
    value: function value() {
      var e;
      return this._awaitLeadershipPromise || (this._awaitLeadershipPromise = (e = this).isLeader ? Promise.resolve() : new Promise(function (t) {
        var n = !1;
        function r() {
          n || (n = !0, clearInterval(i), e._channel.removeEventListener("internal", o), t(!0));
        }
        e.applyOnce().then(function () {
          e.isLeader && r();
        });
        var i = setInterval(function () {
          e.applyOnce().then(function () {
            e.isLeader && r();
          });
        }, e._options.fallbackInterval);
        e._intervals.push(i);
        var o = function o(t) {
          "leader" === t.context && "death" === t.action && e.applyOnce().then(function () {
            e.isLeader && r();
          });
        };
        e._channel.addEventListener("internal", o), e._listeners.push(o);
      })), this._awaitLeadershipPromise;
    }
  }, {
    key: "onDuplicate",
    get: function get() {
      return this._duplicateListeners;
    },
    set: function set(e) {
      this._duplicateListeners = e;
    }
  }, {
    key: "onBeforeDie",
    get: function get() {
      return this._onBeforeDie;
    },
    set: function set(e) {
      this._onBeforeDie = e;
    }
  }, {
    key: "die",
    value: (t = p(y.mark(function e() {
      var t = this;
      return y.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!this.isDead) {
              e.next = 2;
              break;
            }
            return e.abrupt("return");
          case 2:
            return this.isDead = !0, e.next = 5, this.onBeforeDie();
          case 5:
            return this._listeners.forEach(function (e) {
              return t._channel.removeEventListener("internal", e);
            }), this._intervals.forEach(function (e) {
              return clearInterval(e);
            }), this._unloadFns.forEach(function (e) {
              b && window.removeEventListener(e[0], e[1]);
            }), e.abrupt("return", $(this, "death"));
          case 9:
          case "end":
            return e.stop();
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();
function $(e, t) {
  var n = {
    context: "leader",
    action: t,
    token: e.token
  };
  return e._channel.postInternal(n);
}
var q = function q(e) {
  var t = e.type,
    n = e.channelName,
    r = e.fallbackInterval,
    i = e.responseTime,
    o = e.emitOnAllTabs,
    a = e.onIdle,
    s = e.onActive,
    u = e.start,
    c = e.reset,
    l = e.pause,
    h = e.resume,
    f = new F(n, {
      type: t
    }),
    d = function (e, t) {
      if (e._leaderElector) throw new Error("❌ MessageChannel already has a leader-elector");
      var n = new W(e, t);
      return e._beforeClose.push(p(y.mark(function e() {
        return y.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", n.die());
            case 1:
            case "end":
              return e.stop();
          }
        }, e);
      }))), e._leaderElector = n, n;
    }(f, {
      fallbackInterval: r,
      responseTime: i
    }),
    v = {};
  v[d.token] = !1;
  var g = !1,
    b = !0,
    w = function w() {
      return g;
    };
  d.awaitLeadership().then(function () {
    g = !0;
  }), f.addEventListener("message", function (e) {
    var t = m(e, 2),
      n = t[0],
      r = t[1];
    switch (n) {
      case "register":
        v[r] = !1;
        break;
      case "deregister":
        delete v[r];
        break;
      case "idle":
        _(r);
        break;
      case "active":
        T(r);
        break;
      case "emitIdle":
        a();
        break;
      case "emitActive":
        s();
        break;
      case "start":
        u(!0);
        break;
      case "reset":
        c(!0);
        break;
      case "pause":
        l(!0);
        break;
      case "resume":
        h(!0);
    }
  });
  var _ = function _() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : d.token;
      v[e] = !0;
      var t = Object.values(v).every(function (e) {
        return e;
      });
      !b && t && (b = !0, w() ? (a(), o && k("emitIdle")) : k("idle"));
    },
    T = function T() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : d.token;
      v[e] = !1;
      var t = Object.values(v).some(function (e) {
        return !e;
      });
      b && t && (b = !1, w() ? (s(), o && k("emitActive")) : k("active"));
    };
  d.onDuplicate = p(y.mark(function e() {
    return y.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return e.next = 2, d.die();
        case 2:
          return e.abrupt("return", e.sent);
        case 3:
        case "end":
          return e.stop();
      }
    }, e);
  })), d.onBeforeDie = p(y.mark(function e() {
    return y.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return e.next = 2, k("deregister");
        case 2:
          return e.abrupt("return", e.sent);
        case 3:
        case "end":
          return e.stop();
      }
    }, e);
  }));
  var k = function () {
      var e = p(y.mark(function e(t) {
        return y.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", f.postMessage([t, d.token]));
            case 1:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
    E = function () {
      var e = p(y.mark(function e() {
        return y.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, d.die();
            case 2:
              return e.next = 4, f.close();
            case 4:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function () {
        return e.apply(this, arguments);
      };
    }();
  return k("register"), {
    close: E,
    send: k,
    isLeader: w,
    idle: _,
    active: T,
    isAllIdle: function isAllIdle() {
      return b;
    },
    setAllIdle: function setAllIdle(e) {
      b = e;
    }
  };
};
function z(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = f(e);
    if (t) {
      var i = f(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return h(this, n);
  };
}
var H = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && c(e, t);
  }(r, e);
  var n = z(r);
  function r(e) {
    var t;
    if (o(this, r), (t = n.call(this, e)).state = {
      idle: !1,
      oldDate: +new Date(),
      lastActive: +new Date(),
      lastIdle: null,
      idleTime: 0,
      remaining: null,
      pageX: null,
      pageY: null
    }, t.tId = null, t.eventsBound = !1, e.debounce > 0 && e.throttle > 0) throw new Error("onAction can either be throttled or debounced (not both)");
    return e.debounce > 0 ? t._onAction = T(e.onAction, e.debounce) : e.throttle > 0 ? t._onAction = k(e.onAction, e.throttle) : t._onAction = e.onAction, e.eventsThrottle > 0 ? t.handleEvent = k(t._handleEvent.bind(u(t)), e.eventsThrottle) : t.handleEvent = t._handleEvent.bind(u(t)), e.startOnMount && !e.startManually || (t.state.idle = !0), t._toggleIdleState = t._toggleIdleState.bind(u(t)), t.start = t.start.bind(u(t)), t.reset = t.reset.bind(u(t)), t.pause = t.pause.bind(u(t)), t.resume = t.resume.bind(u(t)), t.isIdle = t.isIdle.bind(u(t)), t.getRemainingTime = t.getRemainingTime.bind(u(t)), t.getElapsedTime = t.getElapsedTime.bind(u(t)), t.getLastActiveTime = t.getLastActiveTime.bind(u(t)), t.getLastIdleTime = t.getLastIdleTime.bind(u(t)), t.getTotalIdleTime = t.getTotalIdleTime.bind(u(t)), t.getTotalActiveTime = t.getTotalActiveTime.bind(u(t)), t;
  }
  return s(r, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.props,
        t = e.startOnMount,
        n = e.startManually,
        r = e.crossTab,
        i = e.onIdle,
        o = e.onActive;
      if (r) {
        var a = Object.assign({
            channelName: "idle-timer",
            fallbackInterval: 2e3,
            responseTime: 100,
            removeTimeout: 6e4,
            emitOnAllTabs: !1
          }, !0 === r ? {} : r),
          s = a.type,
          u = a.channelName,
          c = a.fallbackInterval,
          l = a.responseTime,
          h = a.emitOnAllTabs;
        this.manager = q({
          type: s,
          channelName: u,
          fallbackInterval: c,
          responseTime: l,
          emitOnAllTabs: h,
          onIdle: i,
          onActive: o,
          start: this.start,
          reset: this.reset,
          pause: this.pause,
          resume: this.resume
        });
      }
      n || (t ? this.start() : this._bindEvents());
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.debounce !== this.props.debounce && this.props.debounce > 0 ? (this._onAction.cancel && this._onAction.cancel(), this._onAction = T(this.props.onAction, this.props.debounce)) : e.throttle !== this.props.throttle && this.props.throttle > 0 ? (this._onAction.cancel && this._onAction.cancel(), this._onAction = k(this.props.onAction, this.props.throttle)) : (e.throttle && 0 === this.props.throttle || e.debounce && 0 === this.props.debounce) && (this._onAction.cancel && this._onAction.cancel(), this._onAction = this.props.onAction), e.eventsThrottle !== this.props.eventsThrottle && (this._unbindEvents(), this.handleEvent = k(this._handleEvent.bind(this), this.props.eventsThrottle), this._bindEvents()), e.timeout !== this.props.timeout && this.state.idle && this.reset();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      clearTimeout(this.tId), this._unbindEvents(!0), this._onAction.cancel && this._onAction.cancel(), this.manager && this.manager.close().catch(console.error);
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children || null;
    }
  }, {
    key: "_bindEvents",
    value: function value() {
      var e = this;
      if (b) {
        var t = this.props,
          n = t.element,
          r = t.events,
          i = t.passive,
          o = t.capture;
        this.eventsBound || (r.forEach(function (t) {
          n.addEventListener(t, e.handleEvent, {
            capture: o,
            passive: i
          });
        }), this.eventsBound = !0);
      }
    }
  }, {
    key: "_unbindEvents",
    value: function value() {
      var e = this,
        t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (b) {
        var n = this.props,
          r = n.element,
          i = n.events,
          o = n.passive,
          a = n.capture;
        (this.eventsBound || t) && (i.forEach(function (t) {
          r.removeEventListener(t, e.handleEvent, {
            capture: a,
            passive: o
          });
        }), this.eventsBound = !1);
      }
    }
  }, {
    key: "_toggleIdleState",
    value: function value(e) {
      var t = this;
      this.setState(function (e) {
        return {
          idle: !e.idle,
          lastIdle: e.idle ? e.lastIdle : +new Date() - t.props.timeout,
          idleTime: e.idle ? e.idleTime + +new Date() - e.lastIdle : e.idleTime
        };
      }, function () {
        var n = t.props,
          r = n.onActive,
          i = n.onIdle,
          o = n.stopOnIdle;
        t.state.idle ? (o && (clearTimeout(t.tId), t.tId = null, t._unbindEvents()), t.manager ? t.manager.idle() : i(e)) : (t._bindEvents(), t.manager ? t.manager.active() : r(e));
      });
    }
  }, {
    key: "_handleEvent",
    value: function value(e) {
      var t = this.state,
        n = t.remaining,
        r = t.pageX,
        i = t.pageY,
        o = t.idle,
        a = this.props,
        s = a.timeout,
        u = a.stopOnIdle;
      if (this._onAction(e), !n) {
        if ("mousemove" === e.type) {
          if (e.pageX === r && e.pageY === i) return;
          if (void 0 === e.pageX && void 0 === e.pageY) return;
          if (this.getElapsedTime() < 200) return;
        }
        clearTimeout(this.tId), this.tId = null;
        var c = +new Date() - this.getLastActiveTime();
        (o && !u || !o && c > s) && this._toggleIdleState(e), this.setState({
          lastActive: +new Date(),
          pageX: e.pageX,
          pageY: e.pageY
        }), o && u || (this.tId = setTimeout(this._toggleIdleState, s));
      }
    }
  }, {
    key: "start",
    value: function value() {
      var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.setState({
        idle: !1,
        oldDate: +new Date(),
        lastActive: +new Date(),
        remaining: null
      }), this.manager && (this.manager.setAllIdle(!1), !e && this.props.crossTab.emitOnAllTabs && this.manager.send("start"));
      var t = this.props.timeout;
      this.tId = setTimeout(this._toggleIdleState, t);
    }
  }, {
    key: "reset",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.state.idle && this.props.onActive(), this.manager && (this.manager.setAllIdle(!1), !e && this.props.crossTab.emitOnAllTabs && this.manager.send("reset")), this.setState({
        idle: !1,
        oldDate: +new Date(),
        lastActive: +new Date(),
        remaining: null
      });
      var t = this.props.timeout;
      this.tId = setTimeout(this._toggleIdleState, t);
    }
  }, {
    key: "pause",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        t = this.state.remaining;
      null === t && (this._unbindEvents(), clearTimeout(this.tId), this.tId = null, this.manager && !e && this.props.crossTab.emitOnAllTabs && this.manager.send("pause"), this.setState({
        remaining: this.getRemainingTime()
      }));
    }
  }, {
    key: "resume",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        t = this.state,
        n = t.remaining,
        r = t.idle;
      null !== n && (this._bindEvents(), this.manager && !e && this.props.crossTab.emitOnAllTabs && this.manager.send("resume"), r || (this.tId = setTimeout(this._toggleIdleState, n), this.setState({
        remaining: null,
        lastActive: +new Date()
      })));
    }
  }, {
    key: "getRemainingTime",
    value: function value() {
      var e = this.state,
        t = e.remaining,
        n = e.lastActive,
        r = this.props.timeout;
      if (null !== t) return t < 0 ? 0 : t;
      var i = r - (+new Date() - n);
      return i < 0 ? 0 : i;
    }
  }, {
    key: "getElapsedTime",
    value: function value() {
      var e = this.state.oldDate;
      return +new Date() - e;
    }
  }, {
    key: "getLastIdleTime",
    value: function value() {
      return this.state.lastIdle;
    }
  }, {
    key: "getTotalIdleTime",
    value: function value() {
      var e = this.state,
        t = e.idle,
        n = e.lastIdle,
        r = e.idleTime;
      return t ? +new Date() - n + r : r;
    }
  }, {
    key: "getLastActiveTime",
    value: function value() {
      return this.state.lastActive;
    }
  }, {
    key: "getTotalActiveTime",
    value: function value() {
      return this.getElapsedTime() - this.getTotalIdleTime();
    }
  }, {
    key: "isIdle",
    value: function value() {
      return this.state.idle;
    }
  }, {
    key: "isLeader",
    value: function value() {
      return !this.manager || this.manager.isLeader();
    }
  }]), r;
}();
function K() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    i = e.timeout,
    o = void 0 === i ? 12e5 : i,
    a = e.element,
    s = void 0 === a ? w : a,
    u = e.events,
    c = void 0 === u ? _ : u,
    l = e.onIdle,
    h = void 0 === l ? function () {} : l,
    f = e.onActive,
    d = void 0 === f ? function () {} : f,
    v = e.onAction,
    m = void 0 === v ? function () {} : v,
    g = e.debounce,
    E = void 0 === g ? 0 : g,
    A = e.throttle,
    L = void 0 === A ? 0 : A,
    I = e.eventsThrottle,
    O = void 0 === I ? 200 : I,
    x = e.startOnMount,
    S = void 0 === x || x,
    M = e.startManually,
    D = void 0 !== M && M,
    P = e.stopOnIdle,
    j = void 0 !== P && P,
    C = e.capture,
    N = void 0 === C || C,
    B = e.passive,
    R = void 0 === B || B,
    Y = e.crossTab,
    F = void 0 !== Y && Y,
    U = t(!1),
    X = t(!0),
    G = t(+new Date()),
    V = t(null),
    J = t(null),
    W = t(null),
    $ = t(null),
    z = t(null),
    H = t(null),
    K = t(0),
    Q = t(!0),
    Z = t(o),
    ee = t(null);
  F && (!0 === F && (F = {}), F = Object.assign({
    channelName: "idle-timer",
    fallbackInterval: 2e3,
    responseTime: 100,
    removeTimeout: 6e4,
    emitOnAllTabs: !1
  }, F));
  var te = t(h),
    ne = t(d),
    re = t(m);
  n(function () {
    te.current = h;
  }, [h]), n(function () {
    ne.current = d;
  }, [d]), n(function () {
    re.current = m;
  }, [m]);
  var ie = r(function () {
      function e(e) {
        re.current(e);
      }
      return e.cancel && e.cancel(), E > 0 ? T(e, E) : L > 0 ? k(e, L) : e;
    }, [L, E]),
    oe = function oe(e) {
      var t = !X.current;
      X.current = t, t ? (j && (clearTimeout($.current), $.current = null, ce()), H.current = +new Date() - Z.current, ee.current ? ee.current.idle() : te.current(e)) : (K.current += +new Date() - H.current, ue(), ee.current ? ee.current.active() : ne.current(e));
    },
    ae = function ae(e) {
      if (ie(e), !V.current) {
        if ("mousemove" === e.type) {
          if (e.pageX === J && e.pageY === W) return;
          if (void 0 === e.pageX && void 0 === e.pageY) return;
          if (he() < 200) return;
        }
        clearTimeout($.current), $.current = null;
        var t = +new Date() - pe();
        (X.current && !j || !X.current && t > Z.current) && oe(e), z.current = +new Date(), J.current = e.pageX, W.current = e.pageY, X.current || ($.current = setTimeout(oe, Z.current));
      }
    },
    se = t(ae),
    ue = function ue() {
      b && (U.current || (c.forEach(function (e) {
        s.addEventListener(e, se.current, {
          capture: N,
          passive: R
        });
      }), U.current = !0));
    },
    ce = function ce() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      b && (U.current || e) && (c.forEach(function (e) {
        s.removeEventListener(e, se.current, {
          capture: N,
          passive: R
        });
      }), U.current = !1);
    },
    le = function le() {
      if (null !== V.current) return V.current < 0 ? 0 : V.current;
      var e = Z.current - (+new Date() - z.current);
      return e < 0 ? 0 : e;
    },
    he = function he() {
      return +new Date() - G.current;
    },
    fe = function fe() {
      return H.current;
    },
    de = function de() {
      return X.current ? +new Date() - H.current + K.current : K.current;
    },
    pe = function pe() {
      return z.current;
    },
    ve = function ve() {
      return he() - de();
    },
    me = function me() {
      return X.current;
    },
    ge = function ge() {
      return !ee.current || ee.current.isLeader();
    },
    ye = function ye() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      clearTimeout($.current), $.current = null, ue(), X.current = !1, G.current = +new Date(), z.current = +new Date(), V.current = null, ee.current && (ee.current.setAllIdle(!1), !e && F.emitOnAllTabs && ee.current.send("start")), $.current = setTimeout(oe, Z.current);
    },
    be = function be() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      clearTimeout($.current), $.current = null, ue(), X.current && ne.current(), X.current = !1, G.current = +new Date(), z.current = +new Date(), V.current = null, ee.current && (ee.current.setAllIdle(!1), !e && F.emitOnAllTabs && ee.current.send("reset")), $.current = setTimeout(oe, Z.current);
    },
    we = function we() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      null === V.current && (ce(), clearTimeout($.current), $.current = null, V.current = le(), ee.current && !e && F.emitOnAllTabs && ee.current.send("pause"));
    },
    _e = function _e() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      null !== V.current && (ue(), X.current || ($.current = setTimeout(oe, V.current), V.current = null, z.current = +new Date()), ee.current && !e && F.emitOnAllTabs && ee.current.send("resume"));
    };
  return n(function () {
    if (E > 0 && L > 0) throw new Error("onAction can either be throttled or debounced (not both)");
    return F && (ee.current = q({
      type: F.type,
      channelName: F.channelName,
      fallbackInterval: F.fallbackInterval,
      responseTime: F.responseTime,
      emitOnAllTabs: F.emitOnAllTabs,
      onIdle: te.current,
      onActive: ne.current,
      start: ye,
      reset: be,
      pause: we,
      resume: _e
    })), D ? p(y.mark(function e() {
      return y.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (clearTimeout($.current), ce(!0), !F) {
              e.next = 5;
              break;
            }
            return e.next = 5, ee.current.close();
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    })) : (S ? ye() : ue(), p(y.mark(function e() {
      return y.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (clearTimeout($.current), ce(!0), ie.cancel && ie.cancel(), !F) {
              e.next = 6;
              break;
            }
            return e.next = 6, ee.current.close();
          case 6:
          case "end":
            return e.stop();
        }
      }, e);
    })));
  }, []), n(function () {
    var e = U.current;
    e && ce(), se.current = O > 0 ? k(ae, O) : ae, e && ue();
  }, [O]), n(function () {
    Z.current = o, !Q.current && X.current && be(), Q.current = !1;
  }, [o]), {
    isIdle: me,
    isLeader: ge,
    start: ye,
    pause: we,
    reset: be,
    resume: _e,
    getLastIdleTime: fe,
    getTotalIdleTime: de,
    getLastActiveTime: pe,
    getTotalActiveTime: ve,
    getElapsedTime: he,
    getRemainingTime: le
  };
}
H.propTypes = {
  timeout: i.number,
  events: i.arrayOf(i.string),
  onIdle: i.func,
  onActive: i.func,
  onAction: i.func,
  debounce: i.number,
  throttle: i.number,
  eventsThrottle: i.number,
  element: i.oneOfType([i.object, i.element]),
  startOnMount: i.bool,
  startManually: i.bool,
  stopOnIdle: i.bool,
  passive: i.bool,
  capture: i.bool,
  crossTab: i.oneOfType([i.bool, i.shape({
    type: i.oneOf(["broadcastChannel", "localStorage", "simulate"]),
    channelName: i.string,
    fallbackInterval: i.number,
    responseTime: i.number,
    removeTimeout: i.number,
    emitOnAllTabs: i.bool
  })])
}, H.defaultProps = {
  timeout: 12e5,
  element: w,
  events: _,
  onIdle: function onIdle() {},
  onActive: function onActive() {},
  onAction: function onAction() {},
  debounce: 0,
  throttle: 0,
  eventsThrottle: 200,
  startOnMount: !0,
  startManually: !1,
  stopOnIdle: !1,
  capture: !0,
  passive: !0,
  crossTab: !1
}, K.propTypes = {
  timeout: i.number,
  events: i.arrayOf(i.string),
  onIdle: i.func,
  onActive: i.func,
  onAction: i.func,
  debounce: i.number,
  throttle: i.number,
  eventsThrottle: i.number,
  element: i.oneOfType([i.object, i.element]),
  startOnMount: i.bool,
  startManually: i.bool,
  stopOnIdle: i.bool,
  passive: i.bool,
  capture: i.bool,
  crossTab: i.oneOfType([i.bool, i.shape({
    type: i.oneOf(["broadcastChannel", "localStorage", "simulate"]),
    channelName: i.string,
    fallbackInterval: i.number,
    responseTime: i.number,
    removeTimeout: i.number,
    emitOnAllTabs: i.bool
  })])
}, K.defaultProps = {
  timeout: 12e5,
  element: w,
  events: _,
  onIdle: function onIdle() {},
  onActive: function onActive() {},
  onAction: function onAction() {},
  debounce: 0,
  throttle: 0,
  eventsThrottle: 200,
  startOnMount: !0,
  startManually: !1,
  stopOnIdle: !1,
  capture: !0,
  passive: !0,
  crossTab: !1
};
export default H;
export { K as useIdleTimer };